import { useRef } from 'react'
import { useRequest } from 'ahooks'

import { Header, Image } from 'components'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Pagination, Navigation } from 'swiper/modules'

export default function ({ store, navigator }) {
  const res = useRequest<any, any>(() => store.externals.api.get(`/solution/web/all`))
  const result = useRequest<any, any>(() => store.externals.api.get(`/fileManage/list`))

  const icons = [
    {
      title: '全链路过程监控',
      icon: <svg className='w-8 h-8' viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M838.22 756.41H187.78a89.1 89.1 0 0 1-89.1-89.1V198.54a89.1 89.1 0 0 1 89.1-89.1h650.44a89.1 89.1 0 0 1 89.1 89.1v468.77a89.1 89.1 0 0 1-89.1 89.1zM852 671.35V194.5a9 9 0 0 0-9-8.95H183a9 9 0 0 0-9 8.95v476.85a9 9 0 0 0 9 8.94h660a9 9 0 0 0 9-8.94z" fill="#FFFFFF" p-id="1044"></path><path d="M287.01 832.52m37.86 0l376.26 0q37.86 0 37.86 37.86l0 0.39q0 37.86-37.86 37.86l-376.26 0q-37.86 0-37.86-37.86l0-0.39q0-37.86 37.86-37.86Z" fill="#FFFFFF" p-id="1045"></path><path d="M249.34 337.78m31.68 0l11.97 0q31.68 0 31.68 31.68l0 203.04q0 31.68-31.68 31.68l-11.97 0q-31.68 0-31.68-31.68l0-203.04q0-31.68 31.68-31.68Z" fill="#FFFFFF" p-id="1046"></path><path d="M400 451.95m37.67 0l-0.01 0q37.67 0 37.67 37.67l0 76.89q0 37.67-37.67 37.67l0.01 0q-37.67 0-37.67-37.67l0-76.89q0-37.67 37.67-37.67Z" fill="#FFFFFF" p-id="1047"></path><path d="M550.67 261.67m37.67 0l-0.01 0q37.67 0 37.67 37.67l0 267.17q0 37.67-37.67 37.67l0.01 0q-37.67 0-37.67-37.67l0-267.17q0-37.67 37.67-37.67Z" fill="#FFFFFF" p-id="1048"></path><path d="M701.33 413.89m37.67 0l-0.01 0q37.67 0 37.67 37.67l0 114.94q0 37.67-37.67 37.67l0.01 0q-37.67 0-37.67-37.67l0-114.94q0-37.67 37.67-37.67Z" fill="#FFFFFF"></path></svg>
    },
    {
      title: '完善的方案解决能力',
      icon: <svg className='w-8 h-8' viewBox="0 0 1056 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M736.128 0c-176.736 0-320 143.296-320 320a315.84 315.84 0 0 0 22.816 116.128L50.176 824.864C38.944 836.128 32 846.816 32 864v96c0 34.24 29.728 64 64 64h96c17.152 0 28-6.88 39.232-18.048L277.152 960h74.976a64 64 0 0 0 64-64v-64h64a64 64 0 0 0 64-64v-75.008l75.808-75.872c36.128 14.24 75.008 22.88 116.192 22.88 176.672 0 320-143.296 320-320s-143.328-320-320-320z m0 576c-47.36 0-91.264-13.76-129.312-36.224l-11.008 10.976-36 36-60.96 60.992a63.968 63.968 0 0 0-18.752 45.248V768h-64a64 64 0 0 0-64 64v64H277.152a64 64 0 0 0-45.248 18.752l-45.376 45.376L96.096 960 96 868.8l373.28-372.608 0.032 0.064 47.008-47.008c-22.464-38.048-36.224-81.92-36.224-129.28A256.032 256.032 0 1 1 736.128 576z" fill="#FFFFFF" p-id="1210"></path><path d="M922.24 263.648a566.72 566.72 0 0 0-129.76-129.728 30.752 30.752 0 0 0-28.224-4.064c-44.448 15.648-74.88 46.048-90.432 90.496a30.464 30.464 0 0 0 4.064 28.224 567.552 567.552 0 0 0 129.696 129.696 30.912 30.912 0 0 0 28.192 4.096c44.512-15.552 74.944-46.016 90.56-90.496a30.464 30.464 0 0 0-4.096-28.224z m-96 88.672A547.904 547.904 0 0 1 704 230.944c12.384-35.296 35.552-58.464 69.824-71.072a536 536 0 0 1 122.112 121.952c-12.512 35.04-35.616 58.08-69.696 70.496z" fill="#FFFFFF"></path></svg>
    },
    {
      title: '项目整体设计能力',
      icon: <svg className='w-8 h-8' viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M357.376 647.168q0 19.456-16.896 31.744t-42.496 23.552-55.296 25.6-54.272 38.912l-19.456 0q-41.984 0-73.216-8.704t-52.736-23.04-32.256-32.256-10.752-36.352q0-21.504 22.528-34.816t49.664-24.576 49.664-23.552 22.528-31.744-12.288-35.84-27.136-37.376-27.136-49.152-12.288-72.192q0-31.744 6.656-61.44t19.968-52.224 33.792-35.84 48.128-13.312q36.864 0 61.44 12.288-6.144 36.864-6.144 76.8 0 64.512 10.752 109.568t27.136 77.824q-15.36 20.48-28.672 38.4t-13.312 42.496q0 13.312 14.336 23.04t34.304 18.432 42.496 17.92 39.936 19.456q1.024 5.12 1.024 16.384zM865.28 551.936q0 11.264 11.776 20.48t29.184 17.408 38.4 15.872 38.4 16.384 29.184 19.456 11.776 25.088q0 22.528-15.36 39.936t-40.96 29.184-58.88 17.92-68.096 7.168q-28.672-19.456-61.44-30.208t-61.952-19.456-50.176-19.456-25.088-31.232q4.096-19.456 26.624-31.744t48.64-23.04 47.104-23.04 20.992-30.72q0-21.504-16.384-39.424t-33.792-41.472q16.384-35.84 27.136-84.992t10.752-115.712q0-14.336-1.536-28.672t-3.584-28.672q26.624-18.432 48.128-18.432 48.128 0 76.8 15.872t43.52 39.424 19.456 50.688 4.608 49.664q0 46.08-14.848 74.24t-32.768 48.64-32.768 37.888-14.848 40.96zM577.536 660.48q0 21.504 18.944 37.888t47.616 31.232 62.464 28.16 62.464 29.184 47.616 34.816 18.944 44.544q0 17.408-28.672 33.28t-75.776 29.184-108.544 20.992-125.952 7.68q-73.728 0-130.56-7.68t-95.232-20.48-58.368-29.184-19.968-32.768q0-25.6 18.944-44.544t47.616-34.304 61.952-28.16 61.952-27.136 47.616-31.232 18.944-40.448-9.728-44.032-24.576-41.472-32.256-45.568-32.256-55.296-24.576-70.656-9.728-92.16q0-113.664 42.496-180.736t131.584-67.072q74.752 0 117.76 22.528t65.024 57.856 27.648 77.824 5.632 83.456q0 55.296-9.728 95.232t-24.064 69.632-30.72 52.736-30.72 44.032-24.064 43.008-9.728 49.664z" fill='#FFFFFF'></path></svg>
    },
    {
      title: '强大的实施交付能力',
      icon: <svg className='w-8 h-8' viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M208.6 356.3V255.1c0-43.8 35.5-79.3 79.3-79.3h448.2c43.8 0 79.3 35.5 79.3 79.3V439c24.2 9.6 41.4 33.2 41.4 60.9v282.7c0 36.2-29.3 65.5-65.5 65.5H232.7c-36.2 0-65.5-29.3-65.5-65.5V417.2c0-27.7 17.1-51.3 41.4-60.9z m48.3-4.6h186.9c36.2 0 65.5 29.3 65.5 65.5v17.2h257.9V255.1c0-17.2-13.8-31-31-31H287.9c-17.2 0-31 13.8-31 31v96.6z m-24.2 48.2c-9.7 0-17.2 7.6-17.2 17.2v365.5c0 9.7 7.6 17.2 17.2 17.2h558.6c9.7 0 17.2-7.6 17.2-17.2V499.9c0-9.7-7.6-17.2-17.2-17.2H492c-17.2 0-31-13.8-31-31v-34.5c0-9.7-7.6-17.2-17.2-17.2H232.7z m437.9-89.6H353.4c-13.4 0-24.1-10.7-24.1-24.1 0-13.4 10.7-24.1 24.1-24.1h317.2c13.4 0 24.1 10.7 24.1 24.1 0 13.4-10.7 24.1-24.1 24.1z m0 86.2h-100c-13.4 0-24.1-10.7-24.1-24.1 0-13.4 10.7-24.1 24.1-24.1h100c13.4 0 24.1 10.7 24.1 24.1 0 13.4-10.7 24.1-24.1 24.1z" fill="#FFFFFF"></path></svg>
    },
    {
      title: '专业行业咨询能力',
      icon: <svg className='w-8 h-8' viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M843.5 97h-664C115.813 97 64 148.813 64 212.5v440C64 716.187 115.813 768 179.5 768H256v128a31.498 31.498 0 0 0 31.493 31.501 31.501 31.501 0 0 0 22.211-9.157L460.99 768H843.5c63.687 0 115.5-51.813 115.5-115.5v-440C959 148.813 907.187 97 843.5 97zM896 652.5c0 28.948-23.552 52.5-52.5 52.5H448a31.502 31.502 0 0 0-22.204 9.156L319 820.287V736.5c0-17.396-14.103-31.5-31.5-31.5h-108c-28.949 0-52.5-23.552-52.5-52.5v-440c0-28.949 23.551-52.5 52.5-52.5h664c28.948 0 52.5 23.551 52.5 52.5v440z" fill="#FFFFFF" p-id="1690"></path><path d="M736 257H288c-17.397 0-31.5 14.103-31.5 31.5S270.603 320 288 320h448c17.396 0 31.5-14.103 31.5-31.5S753.396 257 736 257zM736 385H288c-17.397 0-31.5 14.103-31.5 31.5S270.603 448 288 448h448c17.396 0 31.5-14.103 31.5-31.5S753.396 385 736 385zM544 513H288c-17.397 0-31.5 14.103-31.5 31.5S270.603 576 288 576h256c17.397 0 31.5-14.103 31.5-31.5S561.397 513 544 513z" fill="#FFFFFF"></path></svg>
    },
    {
      title: '出色的科技创新能力',
      icon: <svg className='w-8 h-8' viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M517.11826 0C275.393086 0 79.338145 196.474639 79.338145 438.854949c0 162.330728 88.182498 303.722654 218.892617 379.641802v95.79335c0 40.403543 32.669852 73.145051 72.986384 73.145051h72.955675c0 20.186417 16.296539 36.564848 36.457365 36.564848h72.960793c20.181298 0 36.498311-16.373313 36.498311-36.564848h72.955675c40.296059 0 72.965912-32.741508 72.965911-73.145051v-95.772877c130.699882-75.914029 218.892617-217.331547 218.892617-379.662275C954.893256 196.474639 758.874143 0 517.11826 0z m145.921586 914.290101H371.212028v-28.042945h291.827818v28.042945z m0-81.692544H371.212028v-28.037827h291.827818v28.037827z m36.380591-77.372733l-21.988044 12.775176h-125.095388l0.429934-161.834256c101.070276-17.105224 178.274107-104.668413 178.274107-210.851831 0-118.436532-95.829178-214.475558-213.922786-214.475558-118.114081 0-213.953496 96.039027-213.953496 214.475558 0 106.188536 77.249895 193.746606 178.289462 210.851831l-1.658317 161.834256H356.834836l-22.003399-12.795649c-112.581242-65.370414-182.522262-186.601515-182.522262-316.349402 0-201.664554 163.666593-365.709899 364.809085-365.709898 201.127137 0 364.788612 164.040226 364.788612 365.709898 0 129.768359-69.905192 250.994342-182.486435 316.369875zM517.11826 538.287382c-78.611352 0-142.615191-64.167623-142.615191-142.978587S438.506908 252.335326 517.11826 252.335326c78.606234 0 142.604954 64.167623 142.604954 142.978587S595.724494 538.287382 517.11826 538.287382z" fill='#FFFFFF'></path></svg>
    },
    {
      title: '项目完整审计能力',
      icon: <svg className='w-8 h-8' viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M927 911.04H97c-16.57 0-30-13.43-30-30s13.43-30 30-30h830c16.57 0 30 13.43 30 30s-13.43 30-30 30z m-592.08-161.8v-250.5c0-23.16-18.84-42-42-42H137.25c-23.16 0-42 18.84-42 42v250.5c0 23.16 18.84 42 42 42h155.67c23.16 0 42-18.84 42-42z m-179.67-232.5h119.67v214.5H155.25v-214.5z m476.59 232.5V315.76c0-23.16-18.84-42-42-42H434.17c-23.16 0-42 18.84-42 42v433.49c0 23.16 18.84 42 42 42h155.67c23.16 0 42-18.84 42-42zM452.17 333.75h119.67v397.49H452.17V333.76z m476.59 415.49V154.96c0-23.16-18.84-42-42-42H731.09c-23.16 0-42 18.84-42 42v594.28c0 23.16 18.84 42 42 42h155.67c23.16 0 42-18.84 42-42zM749.08 172.96h119.67v558.28H749.08V172.96z" fill='#FFFFFF'></path></svg>
    },
    {
      title: '7X24小时维护响应服务',
      icon: <svg className='w-8 h-8' viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M892.992 681.568c19.008 0 28.48 10.88 28.48 32.64v145.12h8.096c9.6 0 17.344 1.28 23.136 3.936 5.824 2.624 8.736 8.352 8.736 17.248 0 7.232-2.368 12.512-7.136 15.84-4.736 3.296-11.84 4.96-21.376 4.96h-11.424v34.88c0 9.6-2.144 16.768-6.4 21.44a21.888 21.888 0 0 1-17.056 7.04 21.696 21.696 0 0 1-16.96-7.2c-4.32-4.8-6.464-11.904-6.464-21.28v-34.88h-94.112c-11.872 0-20.8-2.688-26.72-8.064-5.952-5.376-8.928-12.672-8.928-21.92 0-2.4 0.448-4.8 1.312-7.232a37.44 37.44 0 0 1 3.936-7.68l2.688-3.968 109.088-145.92c6.496-8.768 11.84-15.136 16-19.072a21.248 21.248 0 0 1 15.104-5.888z m-265.12 1.856c19.136 0 35.456 3.008 48.96 9.024a73.6 73.6 0 0 1 23.04 16.48c6.624 7.008 11.776 15.104 15.456 24.32 3.712 9.152 5.536 18.688 5.536 28.576a80 80 0 0 1-11.52 42.24c-7.68 12.704-15.52 22.656-23.52 29.856l-9.824 8.544-13.408 11.264-16.992 14.016c-16.736 13.664-28.8 24.64-36.16 32.864l-2.56 2.944c-3.008 3.392-6.08 7.456-9.184 12.192h97.856c9.76 0 17.184 2.016 22.336 6.016 5.12 4 7.68 9.44 7.68 16.32a21.696 21.696 0 0 1-6.08 15.552c-4.096 4.256-10.24 6.368-18.496 6.368h-137.984c-9.376 0-16.704-2.592-21.952-7.776a24.864 24.864 0 0 1-7.872-18.272c0-4.512 1.696-10.496 5.056-17.92 3.392-7.424 7.072-13.28 11.072-17.536l16.096-16.416 14.976-14.784c4.832-4.672 9.472-9.024 13.92-13.12l9.312-8.448 7.904-6.88c3.584-3.04 6.624-5.472 9.152-7.328l2.336-1.632c10.24-7.264 18.784-14.56 25.6-21.856 6.784-7.328 12-14.816 15.552-22.496 3.552-7.68 5.344-15.232 5.344-22.592 0-8-1.92-15.168-5.728-21.472a39.616 39.616 0 0 0-15.552-14.72 44.896 44.896 0 0 0-21.472-5.248c-16.384 0-29.248 7.168-38.624 21.568a69.152 69.152 0 0 0-4.896 11.456l-1.376 3.904a64.16 64.16 0 0 1-9.92 19.328c-3.712 4.48-9.12 6.72-16.256 6.72a21.12 21.12 0 0 1-15.552-6.176c-4.128-4.128-6.176-9.728-6.176-16.864 0-8.64 1.92-17.6 5.792-27.008 3.872-9.376 9.664-17.856 17.344-25.504 7.68-7.616 17.44-13.76 29.248-18.464 11.84-4.672 25.664-7.04 41.536-7.04zM512 64c247.424 0 448 200.576 448 448a32 32 0 0 1-64 0c0-212.064-171.936-384-384-384S128 299.936 128 512a384.16 384.16 0 0 0 295.68 373.792 32 32 0 0 1-14.688 62.304A448.16 448.16 0 0 1 64 512C64 264.576 264.576 64 512 64z m362.624 686.4l-80.64 108.928h80.64v-108.96zM519.744 256a32 32 0 0 1 32 32v256a31.904 31.904 0 0 1-9.344 22.624l-135.776 135.776a32 32 0 0 1-45.248-45.248l126.4-126.4V288a32 32 0 0 1 32-32z" fill='#FFFFFF'></path></svg>
    },
  ]

  if (store.responsive.isDesktop) {
    return <div>
      <Header
        store={store}
        navigator={navigator} />

      <section>
        <Swiper
          loop={true}
          navigation={false}
          slidesPerView={1}
          modules={[ Autoplay, Pagination, Navigation ]}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          pagination={{ clickable: true, bulletClass: 'swiper-pagination-bullet bg-white' }}
        >
          {result.data?.filter(elm => elm.type == 0).map(elm => {
            return <SwiperSlide key={elm.url} className='select-none'>
              <Image
                alt='banner'
                src={elm.url}
                className='w-full object-cover'
              />
            </SwiperSlide>
          })}
        </Swiper>
      </section>

      <section id='summary' className='px-32 py-16 space-y-8 flex flex-col justify-center min-h-screen 2xl:space-y-16 min-[2560px]:px-64'>
        <h1 className='text-3xl text-gray-800 text-center min-[2560px]:text-5xl'>专精政企数字化转型最后一公里</h1>
        <p className='text-base text-gray-700 text-center leading-loose 2xl:text-2xl 2xl:leading-[1.68] min-[2560px]:text-3xl min-[2560px]:leading-[1.8]'>专精搭建系统间的桥梁，努力消除各系统间的障碍，促进信息流畅和提升协同合作效率。<br/>助力政府、企业实现全面的数字化转型。</p>

        <div className='flex justify-center items-start space-x-8'>
          <div className='w-[50%] flex-none'>
            <Swiper
              loop={true}
              slidesPerView={1}
              modules={[ Autoplay ]}
              autoplay={{ delay: 3000, disableOnInteraction: false }}
            >
              {result.data?.filter(elm => elm.type == 1).map(elm => {
                return <SwiperSlide key={elm} className='select-none'>
                  <Image
                    alt='证书'
                    src={elm.url}
                    className='w-full object-cover'
                  />
                </SwiperSlide>
              })}
            </Swiper>
          </div>
          <div className='flex-auto space-y-4'>
            <h2 className='text-2xl text-gray-800 font-bold 2xl:text-3xl min-[2560px]:text-4xl'>企业简介</h2>
            <p className='text-base text-gray-700 leading-loose 2xl:text-2xl 2xl:leading-[1.68] min-[2560px]:text-3xl min-[2560px]:leading-[1.8]'>公司位于中国光谷,专注于政企数字化转型的最后一公里。汇集研发人才梯队，积累了丰富的自主知识产权。主持过大型信息化软硬件项目的设计、实施、交付和审计经验。</p>
            <p className='text-2xl text-gray-800 font-bold 2xl:text-3xl min-[2560px]:text-4xl'>获得资质:</p>
            <p className='text-base text-gray-700 2xl:text-2xl 2xl:leading-[1.4] min-[2560px]:text-3xl min-[2560px]:leading-[1.68]'>
              ● ISO 9001:2015质量管理体系认证<br/>
              ● IS0 27001:2013信息安全管理体系认证<br/>
              ● 国家级高新技术企业<br/>
              ● 湖北省科技型中小企业<br/>
              ● 湖北省创新型中小企业<br/>
              ● 3A企业信用等级<br/>
              ● 7项发明专利<br/>
              ● 30余项软著
            </p>
          </div>
        </div>
      </section>

      <section id='solution' className='px-32 min-[2560px]:px-64 py-16 space-y-8 bg-cover bg-top bg-no-repeat flex flex-col justify-center min-h-screen 2xl:space-y-16' style={{ backgroundImage: `url(${store.assets.from('/images/103.jpg')})` }}>
        <h3 className='text-3xl text-gray-800 text-center min-[2560px]:text-5xl'>解决方案</h3>
        <p className='text-base text-gray-700 text-center leading-loose 2xl:text-2xl 2xl:leading-[1.68] min-[2560px]:text-3xl min-[2560px]:leading-[1.8]'>我们将提供优质、快速、高效的IT行业解决方案，以帮助客户在竞争激烈的市场中取得成功。<br/>无论您面临何种挑战，我们都能为您提供全方位的支持和服务。</p>

        <ul className='grid grid-cols-4 gap-8 pt-16'>
          {res.data?.map(elm => {
            const res = JSON.parse(elm.data)

            return <li
              key={elm.id}
              onClick={() => navigator.to(`/solution/${elm.id}`)}
              className='px-2 py-4 2xl:py-8 min-[2560px]:py-16 rounded-md bg-white space-y-2 min-[2560px]:space-y-6 hover:bg-blue-100 cursor-pointer'
            >
              <h3 className='text-xl text-gray-800 text-center 2xl:text-2xl min-[2560px]:text-4xl line-clamp-1'>{res.title}</h3>
              <h5 className='text-sm text-center 2xl:text-base min-[2560px]:text-2xl line-clamp-1 text-[#0099FF]'>{res.subtitle}</h5>
              <p className='text-base text-gray-700 text-center pt-2 px-2 2xl:text-xl min-[2560px]:text-3xl line-clamp-1'>{res.case[0]?.title}</p>
            </li>
          })}
        </ul>
      </section>

      <section id='advantage' className='px-32 py-16 space-y-8 flex flex-col justify-center min-h-screen 2xl:space-y-16 2xl:pb-32 min-[2560px]:px-64'>
        <h1 className='text-3xl text-gray-800 text-center min-[2560px]:text-5xl'>为什么选择骤雨湾</h1>
        <p className='text-base text-gray-700 text-center leading-loose 2xl:text-2xl 2xl:leading-[1.68] min-[2560px]:text-3xl min-[2560px]:leading-[1.8]'>公司拥有一支由经验丰富的技术专家组成的团队，在专业领域内拥有深厚的知识储备和实践经验。<br/>无论是软件开发、网络安全还是系统维护，我们都有专业的人才来确保项目的快速响应和高质量完成。</p>

        <div className='pt-32 relative 2xl:pb-16'>
          <div className='flex justify-center items-center'>
            <Image
              alt='icon'
              src={store.assets.from(`/images/101.jpg`)}
              className='object-cover w-96 2xl:w-[32rem] min-[2560px]:w-[40rem]'
            />
          </div>

          <div className='absolute top-0 left-0 pt-16 w-full h-full flex justify-center items-center'>
            <ul className='space-y-8 flex flex-col items-end min-[2560px]:space-y-16'>
              <li className='space-y-2 max-w-[26rem] mr-32 min-[2560px]:mr-[16rem]'>
                <h3 className='text-xl text-[#6e9bd4] text-center 2xl:text-2xl min-[2560px]:text-3xl'>全链路过程监控</h3>
                <p className='text-base text-gray-700 text-center 2xl:text-xl min-[2560px]:text-2xl'>从业务开始到验收结束的整个链路进行端到端的监控，确保各环节的性能、稳定性和可靠性。</p>
              </li>

              <li className='space-y-2 max-w-[26rem] mr-64 min-[2560px]:mr-[32rem]'>
                <h3 className='text-xl text-[#6e9bd4] text-center 2xl:text-2xl min-[2560px]:text-3xl'>完善的方案解决能力</h3>
                <p className='text-base text-gray-700 text-center 2xl:text-xl min-[2560px]:text-2xl'>深入调研用户需求，识别问题、数据收集深入分析问题相关信息、策略制定、风险评估。</p>
              </li>

              <li className='space-y-2 max-w-[26rem] mr-64 min-[2560px]:mr-[32rem]'>
                <h3 className='text-xl text-[#6e9bd4] text-center 2xl:text-2xl min-[2560px]:text-3xl'>专业行业咨询能力</h3>
                <p className='text-base text-gray-700 text-center 2xl:text-xl min-[2560px]:text-2xl'>深入理解行业知识为个人或组织提供战略性建议和解决方案的能力。</p>
              </li>

              <li className='space-y-2 max-w-[26rem] mr-32 min-[2560px]:mr-[16rem]'>
                <h3 className='text-xl text-[#6e9bd4] text-center 2xl:text-2xl min-[2560px]:text-3xl'>项目完整审计能力</h3>
                <p className='text-base text-gray-700 text-center 2xl:text-xl min-[2560px]:text-2xl'>拥有完整的项目审计经验， 制定详细的审计计划确保项目的时间、成本、目标能按计划执行。</p>
              </li>
            </ul>

            <ul className='space-y-8 flex flex-col items-start min-[2560px]:space-y-16'>
              <li className='space-y-2 max-w-[26rem] ml-32 min-[2560px]:ml-[16rem]'>
                <h3 className='text-xl text-[#6e9bd4] text-center 2xl:text-2xl min-[2560px]:text-3xl'>项目整体设计能力</h3>
                <p className='text-base text-gray-700 text-center 2xl:text-xl min-[2560px]:text-2xl'>确保系统设计符合可扩展性、可维护性、易用性、安全性、灵活性。</p>
              </li>

              <li className='space-y-2 max-w-[26rem] ml-64 min-[2560px]:ml-[32rem]'>
                <h3 className='text-xl text-[#6e9bd4] text-center 2xl:text-2xl min-[2560px]:text-3xl'>强大的实施交付能力</h3>
                <p className='text-base text-gray-700 text-center 2xl:text-xl min-[2560px]:text-2xl'>拥有完善的政府、企业交付经验。专业的文档交付验收经验。</p>
              </li>

              <li className='space-y-2 max-w-[26rem] ml-64 min-[2560px]:ml-[32rem]'>
                <h3 className='text-xl text-[#6e9bd4] text-center 2xl:text-2xl min-[2560px]:text-3xl'>7x24小时维护响应服务</h3>
                <p className='text-base text-gray-700 text-center 2xl:text-xl min-[2560px]:text-2xl'>专业团队快速响应，30分钟内找出问题，60分钟内提出解决方案。</p>
              </li>

              <li className='space-y-2 max-w-[26rem] ml-32 min-[2560px]:ml-[16rem]'>
                <h3 className='text-xl text-[#6e9bd4] text-center 2xl:text-2xl min-[2560px]:text-3xl'>出色的科技创新能力</h3>
                <p className='text-base text-gray-700 text-center 2xl:text-xl min-[2560px]:text-2xl'>已获得大数据、区块链和人工智能等领域共7项发明专利的国家级高新技术企业。</p>
              </li>
            </ul>
          </div>
        </div>
      </section>

      <section id='partner'>
        <div className='px-32 pt-16 pb-48 space-y-8 bg-cover bg-center bg-no-repeat 2xl:space-y-16 min-[2560px]:px-64' style={{ backgroundImage: `url(${store.assets.from('/images/102.jpg')})` }}>
          <h1 className='text-3xl text-white text-center min-[2560px]:text-5xl'>合作伙伴</h1>
          <p className='text-base text-white text-center leading-loose 2xl:text-2xl 2xl:leading-[1.68] min-[2560px]:text-3xl min-[2560px]:leading-[1.8]'>我们与众多优秀企业有过合作，这些经验使我们更加成熟和专业。<br/>我们将继续努力，为合作伙伴提供更好的服务和支持，共同创造更加美好的未来。</p>
        </div>

        <ul className='grid grid-cols-5 gap-y-8 gap-x-4 relative -top-24 mx-36 min-[2560px]:mx-64 p-16 shadow-xl rounded-2xl bg-white'>
          {R.times(R.add(1), 20).map((elm, index) => {
            return <li key={index} className='px-4'>
              <Image
                alt='logo'
                className='w-full object-contain select-none'
                src={store.assets.from(`/images/${elm}.png`)}
              />
            </li>
          })}
        </ul>
      </section>
    </div>
  }

  return <div>
    <Header
      store={store}
      navigator={navigator} />

    <main>
      <section>
        <img
          alt='cover'
          className='w-full object-cover'
          src={store.assets.from('/images/104.jpg')}
        />
      </section>

      <section id='summary' className='p-8 space-y-4 bg-white'>
        <h3 className='text-2xl text-gray-800 text-center'>企业简介</h3>
        <p className='text-lg text-gray-700 text-center'>专精政企数字化转型最后一公里</p>
        <p className='text-lg text-gray-700 text-center'>专精搭建系统间的桥梁，努力消除各系统间的障碍，促进信息流畅和提升协同合作效率。助力政府、企业实现全面的数字化转型。</p>

        <Swiper
          loop={true}
          slidesPerView={1}
          modules={[ Autoplay ]}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
        >
          {result.data?.filter(elm => elm.type == 1).map(elm => {
            return <SwiperSlide key={elm.url} className='select-none'>
              <img
                alt='证书'
                src={elm.url}
                className='w-full object-cover'
              />
            </SwiperSlide>
          })}
        </Swiper>

        <p className='indent-[2rem] text-lg text-gray-700'>
          公司位于中国光谷,专注于政企数字化转型的最后一公里。汇集研发人才梯队，积累了丰富的自主知识产权。主持过大型信息化软硬件项目的设计、实施、交付和审计经验。
        </p>

        <p className='text-lg text-gray-700'>获得资质：</p>

        <ul className='list-disc list-inside text-base text-gray-700 space-y-1'>
          <li>ISO 9001:2015质量管理体系认证</li>
          <li>IS0 27001:2013信息安全管理体系认证</li>
          <li>国家级高新技术企业</li>
          <li>湖北省科技型中小企业</li>
          <li>湖北省创新型中小企业</li>
          <li>3A企业信用等级</li>
          <li>7项发明专利</li>
          <li>30余项软著</li>
        </ul>
      </section>

      <section id='solution' className='px-4 py-16 space-y-4 bg-cover bg-top bg-no-repeat' style={{ backgroundImage: `url(${store.assets.from('/images/103.jpg')})` }}>
        <h3 className='text-2xl text-gray-800 text-center px-4'>解决方案</h3>
        <p className='text-lg text-gray-700 text-center px-4'>我们将提供优质、快速、高效的IT行业解决方案，以帮助客户在竞争激烈的市场中取得成功。无论您面临何种挑战，我们都能为您提供全方位的支持和服务。</p>

        <ul className='grid grid-cols-2 gap-2 pt-4'>
          {res.data?.map(elm => {
            const res = JSON.parse(elm.data)

            return <li
              key={elm.id}
              onClick={() => navigator.to(`/solution/${elm.id}`)}
              className='px-1 py-4 rounded-md bg-white space-y-2 hover:bg-blue-100'
            >
              <h3 className='text-base text-gray-800 text-center'>{res.title}</h3>
              <h5 className='text-xs text-gray-700 text-center'>{res.subtitle}</h5>
            </li>
          })}
        </ul>
      </section>

      <section id='advantage' className='px-8 py-16 space-y-4'>
        <h3 className='text-2xl text-gray-800 text-center'>我们的优势</h3>
        <p className='text-lg text-gray-700 text-center'>在专业领域内拥有深厚的知识储备和实践经验。无论是软件开发、网络安全还是系统维护，我们都有专业的人才来确保项目的快速响应和高质量完成。</p>

        <ul className='grid grid-cols-2 gap-8 pt-4'>
          {icons.map((elm, index) => {
            return <li key={index} className='flex flex-col space-y-2 items-center'>
              <div className='p-2 rounded-xl bg-gradient-to-br from-[#c5dff5] to-[#96c9fa]'>{elm.icon}</div>
              <h3 className='text-base text-gray-800 text-center'>{elm.title}</h3>
            </li>
          })}
        </ul>
      </section>

      <section id='partner' className='space-y-4'>
        <div className='p-8 px-6 space-y-4 bg-cover bg-left-top bg-no-repeat' style={{ backgroundImage: `url(${store.assets.from('/images/102.jpg')})` }}>
          <h3 className='text-2xl text-white text-center'>合作伙伴</h3>
          <p className='text-lg text-white text-center'>我们与众多优秀企业有过合作，这些经验使我们更加成熟和专业。我们将继续努力，为合作伙伴提供更好的服务和支持，共同创造更加美好的未来。</p>
        </div>

        <ul className='grid grid-cols-3 gap-8 p-8'>
          {R.times(R.add(1), 20).map((elm, index) => {
            return <li key={index}>
              <img
                alt='logo'
                className='w-full object-contain'
                src={store.assets.from(`/images/${elm}.png`)}
              />
            </li>
          })}
        </ul>
      </section>
    </main>
  </div>
}
